import React, {useRef, useState} from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Spinner from "../Spinner";

const CropperModal = (props) => {
    const cropperRef = useRef(null);
    const [cropperReady, setCropperReady] = useState(false);
    const [cropperData, setCropperData] = useState(null)
    const onCrop = () => {
        const cropper = cropperRef.current?.cropper;
        setCropperData(cropper.getCroppedCanvas().toDataURL())

    };


    const closeModal = () => {

        Reoverlay.hideModal();
    }
    const handleConfirm = () => {
        props.onConfirm(cropperData)
    }
    const handleClose = () => {
        if (props.onClose) {
            props.onClose()
        } else {
            Reoverlay.hideModal()
        }
    }

    return <ModalWrapper onClose={() => {
    }} animation="slideDown" contentContainerClassName="w-11/12 md:8/12 lg:w-4/12 p-5 rounded-xl">

        <div className="modal-content">
            <h1 className="text-center  font-bold text-xl  mb-1  border-gray-100">{props.name}</h1>
            <h1 className="text-center  font-bold text-sm pb-5 mb-5 border-b-2 border-gray-100">{props.description}</h1>
            <div className="cropper-container relative">
                <div className="flex justify-center absolute-center top-50  items-center">
                    {!cropperReady && <Spinner className='text-green-500 text-xl '/>}
                </div>
                <Cropper
                    className={cropperReady ? '' : 'opacity-0 '}
                    src={props.image}
                    minCropBoxHeight={200}
                    minCropBoxWidth={200}
                    style={{height: 300, width: "100%"}}
                    // Cropper.js options
                    ready={event => {
                        setCropperReady(true)
                    }}
                    guides={false}
                    aspectRatio={1}
                    crop={onCrop}
                    ref={cropperRef}
                />
            </div>
            {cropperReady && <div
                className={props.canClose ? 'modal-buttons w-full mt-4 gap-3  grid grid-cols-2' : 'modal-buttons w-full mt-4  grid grid-cols-1'}>
                {

                    props.canClose && <Button onClick={handleClose} rounded="rounded-xl"
                                              theme="light">{props.cancelButtonText || 'لغو'}</Button>
                }

                <Button onClick={handleConfirm} rounded="rounded-xl"
                        theme="green">{props.confirmButtonText || 'تایید'}</Button>
            </div>}

        </div>

    </ModalWrapper>
}
export default CropperModal;